import React from "react";
import { Field } from "formik";
import GridTable from "pages/_components/GridTable/GridTable";
import Checkbox from "pages/_components/Checkbox";
import DateField from "pages/_components/fields/DateField";
import DDJJSubOptionRow from "pages/comex/_components/DDJJSubOptionRow";
import { arrayOf, number, string } from "prop-types";

const FORM_ID = "comex.ddjj.general";

const DDJJSubOptionsV17 = ({ rowStart, subOptions }) => {
    if (!subOptions?.length) {
        return null;
    }
    const handleMainOptionChange = (form, currentOption, checked) => {
        const currentGroup = form.values.v17 || {};

        const updatedGroup = Object.keys(currentGroup)
            .filter((key) => !key.includes("Values"))
            .reduce((acc, key) => {
                acc[key] = key === currentOption ? checked : false;
                return acc;
            }, {});

        const resetValues = {
            option1Values: {
                anual: false,
                trimestral: false,
                periodEnd: "",
            },
        };

        form.setFieldValue("v17", {
            ...currentGroup,
            ...updatedGroup,
            ...(currentOption !== "option1" ? resetValues : {}), // limpia si se eligió option2 u option3
        });
    };

    return subOptions.map((subOption, index) => {
        const row = rowStart + index;
        const className = index === 0 ? "ddjj-suboption-top" : "ddjj-suboption-bottom";

        return (
            <GridTable.Data
                flexDirection="column"
                columnStart={2}
                columnWidth={10}
                rowStart={row}
                key={`v17-${subOption}`}
                className={className}>
                {/* Checkbox principal */}
                <div className="ddjj-inline-checkbox">
                    <Field name={`v17.${subOption}`}>
                        {({ field, form }) => {
                            const handleChange = (checked) => {
                                handleMainOptionChange(form, subOption, checked);
                            };

                            return (
                                <Checkbox
                                    {...field}
                                    idForm={FORM_ID}
                                    name={field.name}
                                    checked={field.value}
                                    labelText={`comex.ddjj.general.v17.${subOption}.label`}
                                    labelClassName="ddjj-inline-content"
                                    onChange={handleChange}
                                />
                            );
                        }}
                    </Field>
                </div>
                {subOption === "option1" && (
                    /* Subcheckboxes */

                    <div className={`indent-40 ${className}`}>
                        {/* Checkbox Anual */}
                        <Field name={`v17.${subOption}Values.anual`}>
                            {({ field, form }) => {
                                const handleChange = (checked) => {
                                    handleMainOptionChange(form, "option1", checked);

                                    form.setFieldValue(`v17.${subOption}Values.anual`, checked);
                                    if (checked) {
                                        form.setFieldValue(`v17.${subOption}Values.trimestral`, false);
                                        form.setFieldValue(`v17.${subOption}Values.periodEnd`, "");
                                    }
                                };

                                return (
                                    <Checkbox
                                        {...field}
                                        idForm={FORM_ID}
                                        name={field.name}
                                        checked={!!field.value}
                                        labelText={`${FORM_ID}.v17.${subOption}.anual.label`}
                                        labelClassName="ddjj-inline-content"
                                        onChange={handleChange}
                                    />
                                );
                            }}
                        </Field>

                        {/* Checkbox Trimestral */}
                        <div className="ddjj-inline-checkbox">
                            <Field name={`v17.${subOption}Values.trimestral`}>
                                {({ field, form }) => {
                                    const handleChange = (checked) => {
                                        handleMainOptionChange(form, "option1", checked);
                                        form.setFieldValue(`v17.${subOption}Values.trimestral`, checked);
                                        if (checked) {
                                            form.setFieldValue(`v17.${subOption}Values.anual`, false);
                                        }
                                    };

                                    return (
                                        <Checkbox
                                            {...field}
                                            idForm={FORM_ID}
                                            name={field.name}
                                            checked={!!field.value}
                                            labelText={`${FORM_ID}.v17.${subOption}.trimestral.label`}
                                            labelClassName="ddjj-inline-content trimestral-text"
                                            onChange={handleChange}
                                        />
                                    );
                                }}
                            </Field>

                            {/* Campo de fecha: siempre visible */}
                            <Field
                                component={DateField}
                                idForm={FORM_ID}
                                name={`v17.${subOption}Values.periodEnd`}
                                hideLabel
                            />
                        </div>
                    </div>
                )}
            </GridTable.Data>
        );
    });
};
DDJJSubOptionsV17.propTypes = {
    rowStart: number.isRequired,
    subOptions: arrayOf(string).isRequired,
};

export default DDJJSubOptionsV17;
